<template>
  <div class="sub-menu-garderob sub-menu">
    <!-- Content -->
    <div
      v-if="content?.garderob?.text"
      class="sub-menu-garderob__text"
    >
      <span v-html="content?.garderob?.text" />
    </div>

    <!-- Links content -->
    <div
      v-if="createLinks.length"
      class="sub-menu-garderob__links"
    >
      <clickable-list
        ref="garderobLinks"
        display-icons
        :links="createLinks"
        @mouseleave="resetList"
      />
    </div>
  </div>
</template>

<script>

/**
 * Vue: Sub menu delivery
 * -----------------------------------------------------------------------------
 * Delivery & returns sub menu component.
 *
 * @param {Object} content - Content to be displayed.
 *
 */
import ClickableList from '~global/clickable-list/clickable-list'

export default {
  name: 'SubMenuGarderob',
  components: {
    ClickableList,
  },

  props: {
    content: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {

    /**
     * Builds a list of links to be fed into a clickable-list component.
     * @returns {Array}
     */
    createLinks() {
      return []
    },
  },

  methods: {

    /**
     * Resets the linklist in the component on mouseleave.
     */
    resetList() {
      const links = this.$refs.garderobLinks

      if (!links) {
        return
      }

      links.resetComponentData()
    },
  },
}
</script>
